import Savings from './Savings';

export default Savings;
